import type { ReactNode } from 'react';
import { BadgeWithTooltip } from '../../BadgeWithTooltip';
import { DemoOrOverlayPageBreadcrumbs } from '../DemoOrOverlayPageBreadcrumbs';
import { TabLayout } from '../TabLayout';
import { OverlayPageActionButtons } from './OverlayPageActionButtons';
import { OverlayPageTitle } from './OverlayPageTitle';

interface OverlayTabLayoutProps {
  children: ReactNode;
  readOnly?: boolean;
}

export const OverlayTabLayout = ({
  children,
  readOnly,
}: OverlayTabLayoutProps) => {
  return (
    <TabLayout
      entity="overlay"
      breadcrumbs={<DemoOrOverlayPageBreadcrumbs />}
      title={<OverlayPageTitle />}
      actionButtons={<OverlayPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      {children}
    </TabLayout>
  );
};
